import { apiUtils } from '../hooks';
import { throwApiError } from '../utils';
import { API_ENDPOINTS } from './apiEndpoints';

class SuperAdminService {
  async calculateAloScore(hotelId: string, isFasttrack?: boolean): Promise<void> {
    // Implementation for calculating ALO score
    try {
      await apiUtils.post(API_ENDPOINTS.aloSuper.calculateAloScore(hotelId, isFasttrack));
    } catch (error) {
      console.error('Failed to calculate ALO score:', error);
      throwApiError(error, 'Failed to calculate ALO score');
    }
  }

  async releaseToHotel(hotelId: string, isFasttrack?: boolean): Promise<any> {
    // Implementation for releasing to hotel
    try {
      const response  = await apiUtils.post(API_ENDPOINTS.aloSuper.releaseToHotel(hotelId, isFasttrack));
      return response;
    } catch (error) {
      console.error('Failed to release to hotel:', error);
      throwApiError(error, 'Failed to release to hotel');
    }
  }
}

export const superAdminService = new SuperAdminService();
